import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

const endpoint: string = environment.apiUrl;

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

interface BudgetUserPermission { 
  id: string,
  name: string,
  email: string,
  is_viewer: boolean,
  is_editor: boolean,
  can_toggle_permission: boolean,
};

@Injectable({
  providedIn: 'root',
})
export class BudgetUserPermissionService {
    private http = inject(HttpClient);

    getCompanyUsers(budgetId: number, moduleIdentifier: number): Observable<BudgetUserPermission> {
        return this.http.get<BudgetUserPermission>(`${endpoint}/api/budget/${budgetId}/user-permissions/${moduleIdentifier}/list`, httpOptions);
    }
  
    togglePermission(budgetId: number, userId: number, moduleIdentifier: number, field: string): Observable<{ success: boolean }> {
      return this.http.put<{ success: boolean }>(`${endpoint}/api/budget/${budgetId}/user-permissions/toggle`, { budgetId, userId, moduleIdentifier, field }, httpOptions);
    }

    getCreatorforBudgetModule(budgetId : number): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/budget/${budgetId}/user-permissions/creator`, httpOptions);
    }

    getViewerByBudgetModulePermission(budgetId : number, moduleIdentifier: number): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/budget/${budgetId}/user-permissions/${moduleIdentifier}/viewers`, httpOptions);
    }
  
    getEditorByBudgetModulePermission(budgetId : number, moduleIdentifier: number): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/budget/${budgetId}/user-permissions/${moduleIdentifier}/editors`, httpOptions);
    }

    getViewersCountGroupedByModules(): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/budget/getViewersCountGroupedByModules`, httpOptions);
    }

    userIsModuleEditorCheck(moduleIdentifier: number): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/budget/${moduleIdentifier}/userIsModuleEditorCheck`, httpOptions);
    }

    hasViewerPermission(budgetId : number, moduleIdentifier: number): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/budget/${budgetId}/user-permissions/${moduleIdentifier}/hasViewerPermission`, httpOptions);
    }

    hasEditorPermission(budgetId : number, moduleIdentifier: number): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/budget/${budgetId}/user-permissions/${moduleIdentifier}/hasEditorPermission`, httpOptions);
    }
}